module.exports = __webpack_public_path__ + "img/page-059.010a2bea.jpg";